
/**
 * Whitelist of authorized users for PharmGrade UK.
 * Add email addresses in lowercase.
 */
export const AUTHORIZED_USERS: string[] = [
  "jonathan.burley@nottingham.ac.uk",
  "frankie.rawson@nottingham.ac.uk"
];
